import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface PictureViewerProps {
  value: boolean
  imgUrls: string[]
  imgIndex?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PictureViewer',
  props: {
    value: { type: Boolean },
    imgUrls: null,
    imgIndex: null
  },
  emits: ['update:value'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  value: boolean
  imgUrls: string[]
  imgIndex?: number
};




const showLightBox = computed({
  get() {
    return props.value
  },
  set(newValue) {
    emits('update:value', newValue)
  },
})

return { __sfc: true,props, emits, showLightBox }
}

})